import { useUserStore } from "../store/userStore";

export function useCanUseSG() {
  const user = useUserStore((state) => state.user);
  const canUseSG = user?.canUseSG === true;

  return { canUseSG };
}

export default useCanUseSG;
